import { Box, Stack, SxProps } from '@chronosphereio/chrono-ui';

// Icon grid cell dimensions
const ICON_SPACING = '2px';
const ICON_CELL_HEIGHT = '4px';
const ICON_CELL_HEIGHT_LARGE = '10px';
const ICON_CELL_WIDTH_2COL = '10px';
const ICON_CELL_WIDTH_3COL = '6px';
const ICON_CELL_WIDTH_4COL = '4px';
const ICON_CELL_WIDTH_FEATURED = '14px';

const sharedStyles: SxProps = {
  backgroundColor: (t) => t.palette.text.primary,
  borderRadius: '0.5px',
};

export const KeepExistingIcon = () => {
  return (
    <Box
      sx={{
        width: '22px',
        height: '20px',
        borderRadius: '0.5px',
        border: (t) => `2px solid ${t.palette.border.default}`,
      }}
    ></Box>
  );
};

export const TwoColumnGridIcon = () => {
  const row = (
    <Stack direction="row" spacing={ICON_SPACING}>
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_2COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_2COL, height: ICON_CELL_HEIGHT }} />
    </Stack>
  );

  return (
    <Stack spacing={ICON_SPACING}>
      {row}
      {row}
      {row}
    </Stack>
  );
};

export const ThreeColumnGridIcon = () => {
  const row = (
    <Stack direction="row" spacing={ICON_SPACING}>
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
    </Stack>
  );

  return (
    <Stack spacing={ICON_SPACING}>
      {row}
      {row}
      {row}
    </Stack>
  );
};

export const FourColumnGridIcon = () => {
  const row = (
    <Stack direction="row" spacing={ICON_SPACING}>
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_4COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_4COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_4COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_4COL, height: ICON_CELL_HEIGHT }} />
    </Stack>
  );

  return (
    <Stack spacing={ICON_SPACING}>
      {row}
      {row}
      {row}
    </Stack>
  );
};

export const FeaturedChartGridIcon = () => {
  const featuredChart = (
    <Stack direction="row" spacing={ICON_SPACING}>
      <Stack direction="row" spacing={ICON_SPACING}>
        <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_FEATURED, height: ICON_CELL_HEIGHT_LARGE }} />
        <Stack spacing={ICON_SPACING}>
          <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
          <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
        </Stack>
      </Stack>
    </Stack>
  );

  const row = (
    <Stack direction="row" spacing={ICON_SPACING}>
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
    </Stack>
  );

  return (
    <Stack spacing="2px">
      {featuredChart}
      {row}
    </Stack>
  );
};

export const DecreasingPriorityGridIcon = () => {
  const twoColRow = (
    <Stack direction="row" spacing={ICON_SPACING}>
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_2COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_2COL, height: ICON_CELL_HEIGHT }} />
    </Stack>
  );
  const threeColRow = (
    <Stack direction="row" spacing={ICON_SPACING}>
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_3COL, height: ICON_CELL_HEIGHT }} />
    </Stack>
  );
  const fourColRow = (
    <Stack direction="row" spacing={ICON_SPACING}>
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_4COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_4COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_4COL, height: ICON_CELL_HEIGHT }} />
      <Box sx={{ ...sharedStyles, width: ICON_CELL_WIDTH_4COL, height: ICON_CELL_HEIGHT }} />
    </Stack>
  );

  return (
    <Stack spacing={ICON_SPACING}>
      {twoColRow}
      {threeColRow}
      {fourColRow}
    </Stack>
  );
};
